export default "__VITE_ASSET__9F4VC9sY__"